import { render, staticRenderFns } from "./userAllRequest.vue?vue&type=template&id=0bee7594&scoped=true"
import script from "./userAllRequest.vue?vue&type=script&lang=js"
export * from "./userAllRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee7594",
  null
  
)

export default component.exports